export default "__VITE_ASSET__a5edbb18__"